"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

require("./SzCardCollapse.scss");

function SzCardCollapse(_a) {
  var header = _a.header,
      body = _a.body,
      footer = _a.footer,
      _b = _a.isActive,
      isActive = _b === void 0 ? false : _b,
      _c = _a.isDisabled,
      isDisabled = _c === void 0 ? false : _c;

  var _d = react_1.useState(isDisabled || !isActive ? false : true),
      active = _d[0],
      setActive = _d[1];

  var eventKey = '0';
  var chevron = active ? 'arrow-down-1' : 'arrow-right-1';
  var iconClasses = classnames_1.default('normal m-0 ', {
    'text-muted': isDisabled
  });
  var headerClasses = 'sz-card-collapse__header d-flex justify-content-between sz-left-border position-relative';
  var toggleButtonClasses = 'bg-white rounded-0 position-relative border-left border-bottom-0 d-flex align-items-center';

  var ToggleHeader = function ToggleHeader(_a) {
    var children = _a.children;
    return isDisabled ? react_1.default.createElement("div", {
      className: headerClasses
    }, children) : react_1.default.createElement(react_bootstrap_1.Accordion.Toggle, {
      className: toggleButtonClasses,
      as: react_bootstrap_1.Card.Header,
      onClick: function onClick() {
        return setActive(!active);
      },
      eventKey: eventKey
    }, children);
  };

  return react_1.default.createElement(react_bootstrap_1.Accordion, {
    className: "sz-card-collapse mb-4",
    defaultActiveKey: isActive ? eventKey : undefined
  }, react_1.default.createElement(react_bootstrap_1.Card, {
    className: "border-0"
  }, react_1.default.createElement("div", {
    className: headerClasses
  }, react_1.default.createElement("div", {
    className: "w-100"
  }, header), react_1.default.createElement(ToggleHeader, null, react_1.default.createElement(SzIcon_1.default, {
    icon: chevron,
    variant: "bold",
    className: iconClasses
  }))), !isDisabled && react_1.default.createElement(react_bootstrap_1.Accordion.Collapse, {
    eventKey: eventKey
  }, react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_bootstrap_1.Card.Body, {
    className: "sz-card-collapse__body d-flex flex-md-row flex-wrap p-0 position-relative text-primary border-top"
  }, body), footer && react_1.default.createElement(react_bootstrap_1.Card.Footer, {
    className: "sz-card-collapse__footer w-100 bg-white rounded-0 position-relative p-3 text-primary"
  }, footer)))));
}

exports.SzCardCollapse = SzCardCollapse;
exports.default = SzCardCollapse;